function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BoardTemplate = require('./board.template');
var Board = /*#__PURE__*/function () {
  function Board(app, mod) {
    _classCallCheck(this, Board);
    this.app = app;
    this.game_mod = mod;
    this.cards_visible = 0;
    this.timer = null;
  }
  return _createClass(Board, [{
    key: "render",
    value: function render() {
      var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (enable) {
        delete this.disable;
      }
      if (this.disable) {
        return;
      }
      if (!this.game_mod.gameBrowserActive() && !this.game_mod.browser_active) {
        return;
      }
      if (!document.querySelector('.poker-board')) {
        this.app.browser.addElementToSelector(BoardTemplate(), '.poker-card-zone');
      }
      this.displayTable();
      this.game_mod.displayHand();
    }
  }, {
    key: "displayTable",
    value: function displayTable() {
      var _this$game_mod$game,
        _this = this;
      var poker_self = this.game_mod;
      var animate_flip = ((_this$game_mod$game = this.game_mod.game) === null || _this$game_mod$game === void 0 || (_this$game_mod$game = _this$game_mod$game.state) === null || _this$game_mod$game === void 0 ? void 0 : _this$game_mod$game.flipped) > 0 && this.game_mod.game.state.flipped > this.cards_visible;
      try {
        var _poker_self$game;
        if (!document.getElementById('deal')) {
          return;
        }
        var pool = (_poker_self$game = poker_self.game) === null || _poker_self$game === void 0 || (_poker_self$game = _poker_self$game.pool) === null || _poker_self$game === void 0 ? void 0 : _poker_self$game[0];
        var pool_hand = (pool === null || pool === void 0 ? void 0 : pool.hand) || [];
        var pool_cards = (pool === null || pool === void 0 ? void 0 : pool.cards) || {};
        var newHTML = '';
        for (var i = 0; i < 5 || i < pool_hand.length; i++) {
          if (i < pool_hand.length && i < this.cards_visible) {
            var card = pool_cards[pool_hand[i]];
            newHTML += "<div class=\"card slot".concat(i + 1, "\"><img class=\"cardFront\" src=\"").concat(poker_self.card_img_dir, "/").concat(card.name, "\"></div>");
          } else if (i < pool_hand.length) {
            var _card = pool_cards[pool_hand[i]];
            newHTML += "<div class=\"flipped slot".concat(i + 1, " card\"><img class=\"cardFront\" src=\"").concat(poker_self.card_img_dir, "/").concat(_card.name, "\"><img class=\"cardBack\" src=\"/poker/img/cards/red.png\"></div>");
          } else {
            newHTML += "<div class=\"flipped slot".concat(i + 1, " card\"><img class=\"cardBack\" src=\"/poker/img/cards/red.png\"></div>");
          }
        }
        document.getElementById('deal').innerHTML = newHTML;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          if (animate_flip && _this.cards_visible < pool_hand.length) {
            for (var _i = 0; _i < pool_hand.length; _i++) {
              var obj = document.querySelector(".slot".concat(_i + 1));
              if (obj) {
                obj.classList.remove('flipped');
              }
            }
          }
          _this.cards_visible = pool_hand.length;
        }, 200);
      } catch (err) {
        console.warn('Card error displaying table:', err);
      }
    }
  }, {
    key: "clearTable",
    value: function clearTable() {
      this.cards_visible = 0;
      this.disable = true;

      //
      // this animation sweeps the cards off the table
      //
      $($('#deal').children().get().reverse()).each(function (index) {
        $(this).delay(50 * index).queue(function () {
          $(this).removeClass('flipped').delay(20 * index).queue(function () {
            $(this).animate({
              left: '1000px'
            }, 1200, 'swing', function () {
              $(this).remove();
            }).dequeue();
          }).dequeue();
        });
      });

      //
      // this animation sweeps revealed hands off the table
      //
      $('.game-playerbox-graphics .hand').animate({
        left: '1000px'
      }, 1200, 'swing', function () {
        $(this).remove();
      });
    }
  }]);
}();
module.exports = Board;